/*eslint-disable*/
import * as React from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { CardSection } from "./CardSection";
import { Button, Flex, Spinner, useToast, Text } from "@chakra-ui/react";
import { TicketDetails } from "./TicketDetails";
import { useQuery } from "../utils/resolvers";
import { ITicket } from "./TicketDetails";
import Axios from "axios";
import { PaymentIntent } from "@stripe/stripe-js";

export default function CheckoutForm() {
  const toast = useToast();
  const query = useQuery();
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = React.useState(false);
  const [ticket, setTicket] = React.useState<ITicket>({
    title: "",
    slug: "",
    description: "",
    price: 0,
    isDeleted: false,
  });
  const [details, setDetails] = React.useState({
    email: "",
    fullName: "",
  });
  const headers = new Headers();
  headers.append("x-api-key", process.env.REACT_APP_API_KEY!);
  headers.append("x-api-secret", process.env.REACT_APP_API_SECRET!);

  React.useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/v1/tickets/${query?.get("ticket")}`,
      {
        method: "GET",
        headers: headers,
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if ([403, 400, 500, 409].includes(parseInt(response.statusCode))) {
          toast({
            title: response.message,
            duration: 9000,
            status: "error",
            position: "top-right",
            isClosable: true,
          });
        } else {
          setTicket(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return () => {};
  }, []);
  const inputFieldChange = async (e: React.FormEvent) => {
    const event = e.target as HTMLButtonElement;
    setDetails((prevState) => {
      return {
        ...prevState,
        [event?.name]: event.value?.trim(),
      };
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      setLoading(true);
      if (!stripe && !elements) {
        return;
      }
      // make the request to get the client secret and publishable key
      const response = await Axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/stripe/payment/create-payment-intent`,
        {
          currency: "usd",
          ticketId: query?.get("ticket"),
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-api-secret": process.env.REACT_APP_API_SECRET,
          },
        }
      );
      if (response) {
        const { clientSecret } = response.data;
        pay(clientSecret);
      }
    } catch (e) {
      setLoading(false);
      toast({
        title:
          e?.response.data.message ??
          "An error occurred processing payment request",
        duration: 9000,
        status: "error",
        position: "top-right",
        isClosable: true,
      });
      console.log(e);
    }
  };

  const pay = async (clientSecret: string) => {
    try {
      const response = await stripe?.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements?.getElement(CardElement)!,
          billing_details: {
            name: details?.fullName,
            email: details?.email,
          },
        },
      });
      if (response?.error) {
        setLoading(false);
        toast({
          title: response?.error.message,
          duration: 9000,
          status: "error",
          position: "top-right",
          isClosable: true,
        });
      } else {
        const {
          amount,
          status,
          currency,
        } = response?.paymentIntent as PaymentIntent;
        setLoading(false);
        if (status === "succeeded") {
          toast({
            title: "Payment Done successfully",
            description: `An amount of ${amount} ${currency} for ${ticket?.title} will be deducted from your accounts`,
            duration: 9000,
            status: "success",
            position: "top-right",
            isClosable: true,
          });
          setTimeout(() => {
            window.location.href = "https://digitalagenetwork.org/";
          }, 4000);
        }
      }
    } catch (e) {
      setLoading(false);
      toast({
        title:
          e?.response.data.message ??
          "An error occurred processing payment request",
        duration: 9000,
        status: "error",
        position: "top-right",
        isClosable: true,
      });
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <Flex flexDirection="column" flexGrow={1} flexWrap="wrap">
        <TicketDetails ticket={ticket} />
        <CardSection handleChange={inputFieldChange} />
        {loading && (
          <Flex
            flexDirection="row"
            flexGrow={1}
            flexWrap="wrap"
            padding="10px"
            justifyContent="center"
          >
            <Spinner />
          </Flex>
        )}
        <Button
          marginTop="20px"
          colorScheme="facebook"
          onClick={handleSubmit}
          disabled={
            !stripe ||
            !elements ||
            loading ||
            details?.email === "" ||
            details?.fullName === ""
          }
        >
          Confirm Order
        </Button>
      </Flex>
    </form>
  );
}
